"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Component = void 0;
var rxjs_1 = require("rxjs");
var util_1 = require("./util");
var Component = /** @class */ (function () {
    function Component(element) {
        this.destroy$ = new rxjs_1.Subject();
        this._initialized = false;
        this.$element = util_1.$helper(element);
    }
    Object.defineProperty(Component.prototype, "element", {
        get: function () {
            return this.$element.element;
        },
        enumerable: false,
        configurable: true
    });
    Component.prototype.init = function () {
        var _this = this;
        this.$element.on('DOMNodeRemoved', function (ev) {
            if (ev.target === _this.$element.element) {
                _this.onRemoved();
            }
        });
        this.onInit();
        this._initialized = true;
        return this;
    };
    Component.prototype.onInit = function () { };
    ;
    Component.prototype.isInitialize = function () {
        return this._initialized;
    };
    Component.prototype.onRemoved = function () {
        this.destroy$.next();
        this.destroy$.complete();
    };
    ;
    Component.prototype.destroy = function () {
        this.$element.remove();
        this.onDestroy();
    };
    Component.prototype.onDestroy = function () { };
    ;
    return Component;
}());
exports.Component = Component;
